module.exports = __webpack_public_path__ + "static/media/module_home_learn.c4bb955a.png";